/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CrmProjectEventActorData
 */
export interface CrmProjectEventActorData {
    /**
     * 
     * @type {CrmProjectEventActorDataTypeEnum}
     * @memberof CrmProjectEventActorData
     */
    type?: CrmProjectEventActorDataTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectEventActorData
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectEventActorData
     */
    name?: string | null;
}


/**
 * @export
 */
export const CrmProjectEventActorDataTypeEnum = {
    User: 'user',
    Admin: 'admin',
    System: 'system',
    Unknown: 'unknown'
} as const;
export type CrmProjectEventActorDataTypeEnum = typeof CrmProjectEventActorDataTypeEnum[keyof typeof CrmProjectEventActorDataTypeEnum];


/**
 * Check if a given object implements the CrmProjectEventActorData interface.
 */
export function instanceOfCrmProjectEventActorData(value: object): value is CrmProjectEventActorData {
    return true;
}

export function CrmProjectEventActorDataFromJSON(json: any): CrmProjectEventActorData {
    return CrmProjectEventActorDataFromJSONTyped(json, false);
}

export function CrmProjectEventActorDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CrmProjectEventActorData {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'userId': json['userId'] === undefined ? undefined : json['userId'] === null ? null : json['userId'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
    };
}

export function CrmProjectEventActorDataToJSON(json: any): CrmProjectEventActorData {
    return CrmProjectEventActorDataToJSONTyped(json, false);
}

export function CrmProjectEventActorDataToJSONTyped(value?: CrmProjectEventActorData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'userId': value['userId'],
        'name': value['name'],
    };
}

